import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import "./index.css"
import "current-script-polyfill"
import * as Sentry from "@sentry/react"

if (process.env.REACT_APP_DEPLOY_ENV !== "") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN
  })
}

ReactDOM.render(<App />, document.getElementById("root"))
